import {
  carsDetailsTranslation,
  CarsDetailsTranslation,
} from '@/assets/locales/views/cars/details/cars.details.translation.pl.ts';
import {
  carsListTranslation,
  CarsListTranslation,
} from '@/assets/locales/views/cars/list/cars.list.translation.pl.ts';
import {
  carsMaintenanceTranslation,
  CarsMaintenanceTranslation,
} from '@/assets/locales/views/cars/maintenance/cars.maintenance.translation.pl.ts';

export type CarsViewTranslation = {
  details: CarsDetailsTranslation;
  list: CarsListTranslation;
  maintenance: CarsMaintenanceTranslation;
};

export const carsViewTranslation: CarsViewTranslation = {
  details: carsDetailsTranslation,
  list: carsListTranslation,
  maintenance: carsMaintenanceTranslation,
};
